// The "current team" is navigation state, not stored server side. It travels
// in the URL as the "team_id" query parameter, so each tab can point at its own
// team and nothing has to be persisted (the shared session cookie / a shared
// database row both forced every tab to share one selection).
export function teamIdFromUrl() {
  return new URLSearchParams(window.location.search).get("team_id") || undefined
}

// Returns +pathOrUrl+ with its "team_id" query parameter set to +teamId+
// (removed when +teamId+ is blank), so callers can navigate with the selection
// without clobbering any other query parameters already on the path. Absolute
// URLs (cross-layout redirects) keep their host.
export function urlWithTeamId(pathOrUrl, teamId) {
  const url = new URL(pathOrUrl, window.location.origin)

  if (teamId) {
    url.searchParams.set("team_id", teamId)
  } else {
    url.searchParams.delete("team_id")
  }

  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(pathOrUrl)) {
    return url.toString()
  }

  return `${url.pathname}${url.search}`
}
